import React from 'react';
import { number, bool } from 'prop-types';
import { Row } from '@thd-olt-component-react/core-ui';
import '../shared-summary.scss';

export const Pricing = ({
  mapExists,
  originalPrice,
  dollarOff,
  valuePrice,
  numItems
}) => {

  return (
    <>
      <Row>
        <span className="package-pricing__pricing-header">Appliances Summary</span>
      </Row>
      <Row className="package-pricing__section">
        <Row className="package-pricing__row">
          <span>Regular Price ({numItems} items)</span>
          {!mapExists ? (
            <span data-testid="package-regular">
              ${originalPrice.toFixed(2)}
            </span>
          ) : (
            <span>-</span>
          )}
        </Row>
        {!!dollarOff && (
          <>
            <Row className="package-pricing__row package-pricing__success">
              <span>Item Savings</span>
              {!mapExists ? (
                <span data-testid="package-savings">
                  -${dollarOff.toFixed(2)}
                </span>
              ) : (
                <span>-</span>
              )}
            </Row>
            <Row className="package-pricing__row">
              <span>Subtotal</span>
              {!mapExists ? (
                <span
                  className="package-pricing__subtotal-result"
                  data-testid="package-subtotal"
                >
                  ${valuePrice.toFixed(2)}
                </span>
              ) : (
                <span className="package-pricing__subtotal-result">-</span>
              )}
            </Row>
          </>
        )}
      </Row>
    </>
  );
};

Pricing.propTypes = {
  mapExists: bool.isRequired,
  originalPrice: number.isRequired,
  dollarOff: number.isRequired,
  valuePrice: number.isRequired,
  numItems: number.isRequired
};
